import './configs/sentry';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { AppStateContextProvider } from './store';
import { App } from './App';

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AppStateContextProvider>
      <App />
    </AppStateContextProvider>
  </BrowserRouter>,
);
